<template>
  <div class="page-container">
    <div class="signin-container">
      <div class="signin-title">Sign In</div>
      <div class="signin-form">
        <el-form
          ref="signinForm"
          label-position="left"
          label-width="150px"
          :model="signinForm"
          :rules="formRules"
        >
          <el-form-item label="Username" prop="username">
            <el-input v-model="signinForm.username"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password">
            <el-input
              type="password"
              show-password
              v-model="signinForm.password"
            ></el-input>
          </el-form-item>
          <el-form-item label="Veirification Code" prop="captcha">
            <div class="veri-wrapper">
              <div class="veri-left">
                <el-input
                  style="width: 150px"
                  v-model="signinForm.captcha"
                ></el-input>
              </div>
              <div class="veri-right">
                <img
                  height="50px"
                  :src="captchaText"
                  alt="verification code"
                  @click="getVerCode"
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-group-wrapper">
        <el-button
          :loading="signInBtnLoading"
          type="primary"
          @click="signIn(signinForm)"
          >Sign In</el-button
        >
        <el-button @click="signUp">Sign Up</el-button>
      </div>
    </div>
    <el-dialog title="Supplementary Information" :visible.sync="moreInfo2Fill">
      <el-form :model="moreInfoform">
        <el-form-item label="Region" label-width="100px">
          <el-input v-model="moreInfoform.region" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Affiliation" label-width="100px">
          <el-input
            v-model="moreInfoform.institution"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <div class="dialog-comment">
          * Please provide the above information to continue logging in
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moreInfo2Fill = false">Cancel</el-button>
        <el-button type="primary" @click="submitMoreInfo(moreInfoform)"
          >Submit</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { uuid } from "uuidv4";
import {
  signInToAceMap,
  getVerication,
  getUserInfo,
  editUserInfo,
} from "@/api/user.js";
const USER_INFO_VUE_COOKIE_EXP_TIME = 60 * 60 * 24;
export default {
  name: "signIn",
  data() {
    return {
      // 旧用户登录，是否弹出补充信息模态框
      moreInfo2Fill: false,
      // 登录按钮Loading态
      signInBtnLoading: false,
      // 邮箱密码验证规则
      formRules: {
        username: [
          {
            required: true,
            message: "Please Input Your Username",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "Please Input Your Password",
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: "Please Input the Verification Code On the Right",
            trigger: "blur",
          },
        ],
      },
      // uuid
      uuid: "",
      // 验证码图片地址
      captchaText: "",
      // 登录表单输入内容
      signinForm: {
        username: "",
        password: "",
        captcha: "",
      },
      // 补充信息表单输入内容
      moreInfoform: {
        institution: "",
        region: "",
      },
      // 用于临时记录当前登录获取的accessToken
      accessToken: "",
      // 用于临时记录当前登录获取的用户等级
      level: null,
      // 用于临时记录当前登录获取的用户ID
      userID: null,
    };
  },
  mounted() {
    this.uuid = uuid();
    this.getVerCode();
  },
  watch: {
    // moreInfo2Fill置为false时指用户退出补充信息，提示登录失败
    moreInfo2Fill(newVal) {
      if (!newVal) {
        this.$message({
          message:
            "This account has information that needs to be supplemented. Please log in again.",
          type: "warning",
          center: true,
        });
      }
    },
  },
  methods: {
    // 验证码图片转化
    arrayBufferToBase64(data) {
      let blob = new Blob([data], { type: "image/png" });
      const Fr = new FileReader();
      Fr.readAsDataURL(blob);
      Fr.onload = (event) => {
        // 转换为的base64图片地址
        this.captchaText = event.target.result;
      };
    },
    // 获取验证码
    getVerCode() {
      getVerication(this.uuid).then((res) => {
        const status = res.status + "";
        if (status.startsWith("2")) {
          this.arrayBufferToBase64(res.data);
        }
      });
    },
    // 点击登录按钮
    async signIn(signinForm) {
      this.$refs["signinForm"].validate(async (valid) => {
        if (valid) {
          this.signInBtnLoading = true;
          try {
            const params = {
              username: signinForm.username,
              password: signinForm.password,
              captcha_text: signinForm.captcha,
              captcha_uuid: this.uuid,
            };
            // 登录换取token
            const {
              data: { access_token: accessToken },
            } = await signInToAceMap(params);
            // state记录换取的token
            this.accessToken = accessToken;
            // token换取用户信息并判断是否需要补充信息
            const {
              data: { region: hasRegionInfo, level, user_id: userID },
            } = await getUserInfo(accessToken);
            this.level = level;
            this.userID = userID;
            if (accessToken && hasRegionInfo) {
              // 已有地区和机构字段的用户登录
              this.setAuthCookie(
                accessToken,
                signinForm.username,
                this.level,
                this.userID
              );
              this.$store.commit("SET_NAME", signinForm.username);
              this.$store.commit("SET_USER_LEVEL", this.level);
              this.$router.push("/");
            }
            if (!hasRegionInfo) {
              // 用户需要补充地区和机构字段
              this.moreInfo2Fill = true;
            }
            this.$notify({
              title: "Success",
              message:
                "Hello, " +
                signinForm.username +
                ". You have successfully logged in.",
              type: "success",
            });
          } catch (err) {
            console.log("ERROR:", err);
          }
          this.signInBtnLoading = false;
        } else {
          return false;
        }
      });
    },
    // 点击注册按钮
    signUp() {
      window.open("https://ddescholar.acemap.info/signIn", "_blank");
    },
    // 在 COOKIE 中储存登录态
    setAuthCookie(accessToken, username, level, userID) {
      Vue.$cookies.set(
        "accessToken",
        accessToken,
        USER_INFO_VUE_COOKIE_EXP_TIME
      );
      Vue.$cookies.set("userName", username, USER_INFO_VUE_COOKIE_EXP_TIME);
      Vue.$cookies.set("userLevel", level, USER_INFO_VUE_COOKIE_EXP_TIME);
      Vue.$cookies.set("userID", userID, USER_INFO_VUE_COOKIE_EXP_TIME);
    },
    // 补充信息确认框中点击确认
    async submitMoreInfo(moreInfoform) {
      console.log(moreInfoform);
      try {
        await editUserInfo(moreInfoform, this.accessToken);
        // 注意此时还没有保存用户的登录态，利用state做持续存储
        this.setAuthCookie(
          this.accessToken,
          this.signinForm.username,
          this.level,
          this.userID
        );
        this.$router.push("/");
      } catch (err) {
        console.log("ERROR", err);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page-container {
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    linear-gradient(117.26deg, #58e1ff -12.31%, #0047ff 100%);
  min-height: 100vh;
  box-sizing: border-box;
  font-family: "Source Sans Pro", "PingFang SC";
}
.dialog-comment {
  color: #aaa;
}
.signin-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 650px;
  max-width: 100%;
  height: 400px;
  max-height: 100%;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(20px);
  border-radius: 10px;
  padding: 20px 60px 20px 60px;
  box-sizing: border-box;

  .signin-title {
    padding-top: 15px;
    font-size: 32px;
    line-height: 50px;
    font-weight: 900;
    text-align: center;
  }
  .signin-form {
    font-weight: 600;
    height: auto;
    width: 100%;
    text-align: left;
    margin-top: 30px;

    .veri-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      flex-wrap: wrap;
    }
    .veri-left {
      width: 100%;
      max-width: 150px;
      margin-bottom: 10px;
    }
    .veri-right {
      margin-top: 0;
      margin-left: 10px;
      height: 50px;
      flex-grow: 1;
    }
  }
  .btn-group-wrapper {
    margin-top: 20px;
    text-align: center;
  }
}

@media screen and (max-width: 768px) {
  .signin-container {
    width: 90%;
    height: auto;
    padding: 20px;
  }
  .signin-title {
    font-size: 24px;
    line-height: 30px;
  }
  .signin-form {
    margin-top: 20px;
  }
  .veri-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }
  .veri-left,
  .veri-right {
    width: 100%;
    margin-left: 0;
  }
  .veri-right {
    margin-top: 10px;
  }
}
</style>
